import { Typography } from 'antd';
import { ParagraphProps } from 'antd/lib/typography/Paragraph';
import { APP_COLORS, APP_SIZES } from 'constants/vars';
import styled, { css } from 'styled-components';

const { Text } = Typography;

interface IProps extends Omit<ParagraphProps, 'size' | 'color'> {
  $color: keyof typeof APP_COLORS;
  $size: keyof typeof APP_SIZES;
  $fontWeight?: string;
  $textAlign?: string;
  $lineHeight?: number;
}

export const StyledParagraph = styled(Text)<IProps>`
  ${({ $color, $fontWeight, $size, $textAlign, $lineHeight }) => css`
    &&& {
      color: ${APP_COLORS[$color]};
      margin-bottom: 0;
      text-align: ${$textAlign};
      line-height: ${$lineHeight};
      font-weight: ${$fontWeight};
      font-size: ${APP_SIZES[$size]};
    }
  `}
`;
